var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.0625C5.17066 2.0625 2.0625 5.17066 2.0625 9C2.0625 12.8293 5.17066 15.9375 9 15.9375C12.8293 15.9375 15.9375 12.8293 15.9375 9C15.9375 5.17066 12.8293 2.0625 9 2.0625ZM0.9375 9C0.9375 4.54934 4.54934 0.9375 9 0.9375C13.4507 0.9375 17.0625 4.54934 17.0625 9C17.0625 13.4507 13.4507 17.0625 9 17.0625C4.54934 17.0625 0.9375 13.4507 0.9375 9Z",
    fill: "#65676B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72266 5.07031C9.03332 5.07031 9.28516 5.32215 9.28516 5.63281V8.70781C9.28516 8.82297 9.32913 8.98989 9.42691 9.16134C9.52471 9.33284 9.64591 9.45552 9.74442 9.5139L9.74591 9.51478L9.74591 9.51479L12.0709 10.9023C12.3377 11.0615 12.4249 11.4068 12.2657 11.6736C12.1065 11.9403 11.7612 12.0275 11.4944 11.8683L9.17089 10.4817C9.17063 10.4816 9.17037 10.4814 9.17011 10.4813C8.86399 10.2996 8.61796 10.0138 8.44965 9.71865C8.28118 9.42324 8.16016 9.06515 8.16016 8.70781V5.63281C8.16016 5.32215 8.412 5.07031 8.72266 5.07031Z",
    fill: "#65676B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.58a919d6e8b47ff295a751ffbcb8e62d.svg";
export { ForwardRef as ReactComponent };